import React from "react";
import { useTheme } from "../../../../theme/ThemeProvider";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function CustomChart(props) {
  const { lineChartData, unit } = props;
  const { theme } = useTheme();
  const totalNumData = lineChartData.length;
  let xAxisTime;
  if (totalNumData < 6) {
    xAxisTime = lineChartData.map(item => item.jsTime);
  } else {
    xAxisTime = [
      lineChartData[0]["jsTime"],
      lineChartData[Math.ceil(totalNumData / 6)]["jsTime"],
      lineChartData[Math.ceil((2 * totalNumData) / 6)]["jsTime"],
      lineChartData[Math.ceil((3 * totalNumData) / 6)]["jsTime"],
      lineChartData[Math.ceil((4 * totalNumData) / 6)]["jsTime"],
      lineChartData[Math.ceil((5 * totalNumData) / 6)]["jsTime"],
      lineChartData[totalNumData - 1]["jsTime"],
    ];
  }

  const lineKeys = Object.keys(lineChartData[0]).filter(key => key !== "jsTime");
  const brightColors = [
    "#FF5733", "#5733FF", "#FFD700", "#FF33A1", "#33A1FF",
    "#A1FF33", "#FF8C33", "#8C33FF", "#FF4500", "#8CFF33"
  ];

  const totalStroke = theme === "dark" ? "#ffffff" : "#222222";
  const axisColor = theme === "dark" ? "#e9ecef" : "#212529";
  const gridColor = theme === "dark" ? "#495057" : "#dee2e6";

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        width={500}
        height={300}
        data={lineChartData}
        margin={{
          top: 5,
          right: 55,
          left: 45,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
        <XAxis dataKey="jsTime" ticks={xAxisTime} tick={{ fill: axisColor }} stroke={gridColor} />
        <YAxis unit={unit} tick={{ fill: axisColor }} stroke={gridColor} />

        <Tooltip />
        <Legend />
        {lineKeys.map((key, index) => (
          <Line
            key={index}
            type="monotone"
            dataKey={key}
            stroke={ key === "total" ? totalStroke : brightColors[index % brightColors.length]}
            dot={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
